<template lang="pug">
	modal(v-if="registro")
		.card.text-left
			.card-header(:class="(registro.cancelada) ? 'bg-danger text-white' : ''")
				span(v-if="!registro.cancelada")
					i.fa.fa-edit.mr-2
					| Editor
				span(v-else)
					i.fa.fa-exclamation.mr-2
					| Esta cita fue cancelada
				button.close(@click="cerrar") &times;
			.card-body
				h4
					i.fa.fa-info-circle.mr-2
					| Datos básicos
					small.ml-3(v-if="registro.fecha_registro")
						| (Fecha de registro: {{registro.fecha_registro | moment('DD-MM-YYYY')}} a las {{registro.fecha_registro | moment('HH:mm:ss')}})
				.row
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group
							label Tipo
							br
							.btn-group
								button.btn(:class="(registro.gestion === 0) ? 'btn-primary' : ''", @click="registro.gestion = 0") Contacto cliente
								button.btn(:class="(registro.gestion === 1) ? 'btn-primary' : ''", @click="registro.gestion = 1") Gestión interna
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group
							label Agente
							.input-group
								.input-group-prepend
									.input-group-text
										i.fa.fa-user
								input-query(v-if="!registro.usuario_ID", url="/agenda-comercial/php/api/busca-agentes.php", :realtime="true", placeholder="Selecciona agente", input-class="form-control form-control-sm", @selected="seleccionaAgente($event)")
								input.form-control.form-control-sm(v-if="registro.usuario_ID", disabled, :value="registro.usuarioNombre")
								.input-group-append(v-if="registro.usuario_ID && editable")
									button.btn.btn-danger.btn-sm(@click="quitarAgente", v-if="permisos.agenda_comercial_crear_todos")
										span.fa.fa-trash
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4(v-if="!registro.gestion")
						.form-group
							label Cliente
							.input-group
								.input-group-prepend
									.input-group-text
										i.fa.fa-building
								input-query(
									v-if="!registro.cliente_ID",
									:disabled="!registro.usuario_ID",
									:url="'/agenda-comercial/php/api/busca-clientes.php?agente=' + registro.usuario_ID",
									:realtime="true",
									placeholder="Selecciona cliente",
									input-class="form-control form-control-sm",
									@selected="seleccionaCliente($event)",
									ref="inpCliente"
								)
								input.form-control.form-control-sm(v-if="registro.cliente_ID", disabled, :value="registro.clienteNombre")
								.input-group-append(v-if="registro.cliente_ID && editable")
									button.btn.btn-danger.btn-sm(@click="quitarCliente")
										span.fa.fa-trash

				// hr
				.row.mt-4(v-if="registro.usuario_ID && (registro.cliente_ID || registro.gestion === 1)")
					.col-xs-12.col-sm-12.col-md-6.col-xl-6.col-xl-6
						.row
							.col-xs-4.col-sm-4.col-md-4.col-lg-4.col-xl-4
								.form-group
									label Día
									datepicker(
										v-if="editable"
										v-model="registro.fechaContacto",
										:language='$dateLang',
										:monday-first="true"
										:bootstrap-styling="true"
										input-class="form-control form-control-sm"
										placeholder="Fecha"
									)
									input.form-control.form-control-sm(v-if="!editable", disabled, :value="$moment(registro.fechaContacto).format('D MMM YYYY')")
							.col-xs-4.col-sm-4.col-md-4.col-lg-4.col-xl-4
								.form-group
									label Hora de inicio
									input.form-control.form-control-sm(v-mask="'##:##'", v-model="registro.horaIni", :disabled="!editable")
							.col-xs-4.col-sm-4.col-md-4.col-lg-4.col-xl-4
								.form-group
									label Hora de fin
									input.form-control.form-control-sm(v-mask="'##:##'", v-model="registro.horaFin", :disabled="!editable")
					.col-xs-12.col-sm-12.col-md-6.col-xl-6.col-xl-6(v-if="registro.gestion === 0")
						.row
							.col-xs-6.col-sm-6.col-md-6.col-lg-6.col-xl-6
								.form-group
									label Tipo de contacto
									select.form-control.form-control-sm(v-model="registro.tipo_contacto_ID", :disabled="!editable")
										option(:value="null") Selecciona
										option(v-for="tipo in listadoTipos", :key="tipo.ID_tipo", :value="tipo.ID_tipo") {{tipo.nombre}}
							.col-xs-6.col-sm-6.col-md-6.col-lg-6.col-xl-6
								.form-group
									label Objetivo del contacto
									select.form-control.form-control-sm(v-model="registro.objetivo_contacto_ID", :disabled="!editable")
										option(:value="null") Selecciona
										option(v-for="objetivo in listadoObjetivos", :key="objetivo.ID_objetivo", :value="objetivo.ID_objetivo") {{objetivo.nombre}}
			.card-body.bg-light(v-if="registro.ID_entrada && registro.gestion === 0")
				div.row
					div.col
						h4
							i.fa.fa-money.mr-2
							| Propuestas
					div.col.text-right(v-if="!registro.fecha_cierre_informe")
						.input-group.input-group-sm.text-left
							input-query(
								placeholder="Busca una propuesta para asignar o copiar"
								inputClass="form-control form-control-sm"
								:url="'/agenda-comercial/php/api/query-propuestas.php?ID_cliente=' + registro.cliente_ID"
								:realtime="true"
								@selected="asignaPropuesta($event.datos)"
							)
							.input-group-append
								button.btn.btn-primary.btn-sm.pull-right(@click="verEditorPropuestas = true") Nueva
			div.table-responsive(v-if="registro.ID_entrada && registro.propuestas.length > 0")
				table.table.table-striped
					thead.bg-warning
						tr
							th Título propuesta
							th Importe
							th ¿Presentada?
							th Estado
							th
					tbody
						tr(v-for="p in registro.propuestas", :key="p.ID_propuesta")
							td
								span.fa.fa-caret-right.mr-2
								| {{p.titulo}}
							td {{p.importe | currency('€')}}
							td
								span(v-if="p.fecha_presentada")
									| Presentada
									div(v-if="p.entrada_ID_presentada === registro.ID_entrada", style="opacity: 0.7;")
										| hoy
									div(v-else, style="opacity: 0.7;")
										| {{p.fecha_presentada | moment('DD-MM-YYYY')}}
								span(v-else-if="!registro.fecha_cierre_informe && new Date().getTime() / 1000 > registro.fecha_fin_contacto")
									button.btn.btn-warning.btn-sm(@click="setPresentada(p.ID_propuesta)")
										span.fa.fa-check.mr-2
										| La he presentado
								span(v-else)
									| No presentada
							td
								span(v-if="p.decision === 'aprobada'")
									| Aprobada
									br
									span(style="opacity: 0.7;") {{p.fecha_decision | moment('DD-MM-YYYY')}}
								span(v-else-if="p.decision === 'rechazada'") Rechazada
									br
									span(style="opacity: 0.7;") {{p.fecha_decision | moment('DD-MM-YYYY')}}
								span(v-else-if="!p.decision && p.fecha_presentada && !registro.fecha_cierre_informe")
									button.btn.btn-sm.btn-primary.m-1(@click="setDecision(p.ID_propuesta, 'aprobada')") Aprobar
									button.btn.btn-sm.btn-danger.m-1(@click="setDecision(p.ID_propuesta, 'rechazada')") Rechazar
								span(v-else)
									| Pendiente
							td.text-right
								button.btn.btn-sm.btn-primary(@click="detallePropuesta = p.ID_propuesta")
									span.fa.fa-eye
								button.btn.btn-sm.btn-danger.m-1(v-if="!p.fecha_presentada && !registro.fecha_cierre_informe", @click="desasignaPropuesta(p.ID_propuesta)")
									span.fa.fa-trash
			.card-body(v-if="registro.usuario_ID && (registro.cliente_ID || registro.gestion === 1)")
				h4
					i.fa.fa-comments.mr-2
					| Comentarios
					span(v-if="registro.gestion === 0") previos
				textarea.form-control.form-control-sm(rows="6", v-model="registro.comentarios_previos", :disabled="!editable")

				div.mt-4
					h4
						i.fa.fa-comments.mr-2
						| Comentarios finales
					textarea.form-control.form-control-sm(:disabled="registro.fecha_cierre_informe", rows="6", v-model="registro.comentarios_finales")
			.card-footer
				button.btn.btn-primary.btn-sm.m-2(@click="guardar", v-if="formValido && editable")
					i.fa.fa-trash.mr-2
					| Guardar
				button.btn.btn-danger.btn-sm.m-2(@click="eliminar", v-if="registro.ID_entrada && editable")
					i.fa.fa-save.mr-2
					| Eliminar
				button.btn.btn-warning.btn-sm.m-2(v-if="registro.gestion === 0 && citaPasada && !registro.fecha_cierre_informe", @click="finalizar")
					span.fa.fa-check.mr-2
					| Finalizar informe
				button.btn.btn-danger.btn-sm.m-2(v-if="registro.gestion === 0 && registro.ID_entrada && !registro.fecha_cierre_informe && !accionesPropuestas", @click="cancelando = true")
					span.fa.fa-close.mr-2
					| Cita cancelada
		propuesta(v-if="verEditorPropuestas", @cerrar="verEditorPropuestas = false", :copiar="copiarPropuesta", :id-agente="registro.usuario_ID", :id-cliente="registro.cliente_ID", @saved="asignaPropuesta($event)")
		propuesta(v-if="detallePropuesta", :id-propuesta="detallePropuesta", @cerrar="detallePropuesta = null")
		cancelar-cita(:id-entrada="registro.ID_entrada", @cerrar="cancelando = false", v-if="cancelando", @cancelada="citaCancelada")
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import EditorPropuestas from '../propuestas/editor-propuestas'
import MenuCancelar from './cancelar'

const uri = '/agenda-comercial/php/api/'

export default {
	props: ['idRegistro', 'fecha', 'hora'],
	components: {
		'propuesta': EditorPropuestas,
		'cancelar-cita': MenuCancelar
	},
	data () {
		return {
			verEditorPropuestas: false,
			copiarPropuesta: null,
			registro: null,
			listadoTipos: [],
			listadoObjetivos: [],
			detallePropuesta: null,
			cancelando: false
		}
	},

	created () {
		if (this.idRegistro === 'nuevo') {
			this.nuevo()
		} else {
			this.getEntrada(this.idRegistro)
		}

		// Obtenemos el listado de tipos de contacto
		axios.get(uri + 'get-listado-tipos.php')
			.then(res => {
				this.listadoTipos = res.data
			})
			.catch(this.apiError)
		// Obtenemos eli listado de objetivos
		axios.get(uri + 'get-listado-objetivos.php')
			.then(res => {
				this.listadoObjetivos = res.data
			})
			.catch(this.apiError)
	},

	computed: {
		...mapGetters({
			'permisos': 'permisos/permisos',
			'usuario': 'session/usuario'
		}),
		horaIniValida () {
			if (!this.registro || !this.registro.horaIni || typeof this.registro.horaIni !== 'string') {
				return false
			}

			if (!this.registro.horaIni.match(/^[0-9]{2}:[0-9]{2}$/)) {
				return false
			}

			const hora = parseInt(this.registro.horaIni.split(':')[0])
			const minutos = parseInt(this.registro.horaIni.split(':')[1])

			if (hora > 23 || minutos > 59) {
				return false
			}

			return true
		},

		horaFinValida () {
			if (!this.horaIniValida) {
				return false
			}
			if (!this.registro || !this.registro.horaFin || typeof this.registro.horaFin !== 'string') {
				return false
			}

			if (!this.registro.horaFin.match(/^[0-9]{2}:[0-9]{2}$/)) {
				return false
			}

			const hora = parseInt(this.registro.horaFin.split(':')[0])
			const minutos = parseInt(this.registro.horaFin.split(':')[1])

			if (hora > 23 || minutos > 59) {
				return false
			}

			const horaIni = parseInt(this.registro.horaIni.split(':')[0])
			const minutosIni = parseInt(this.registro.horaIni.split(':')[1])

			if (hora < horaIni) {
				return false
			}

			if (hora === horaIni && minutos <= minutosIni) {
				return false
			}
			return true
		},

		formValido () {
			return (
				this.registro &&
				this.registro.usuario_ID &&
				(this.registro.cliente_ID || this.registro.gestion === 1) &&
				(this.registro.fecha_inicio_contacto || this.registro.fechaContacto) &&
				this.horaIniValida &&
				this.horaFinValida &&
				(
					this.registro.gestion === 1 ||
					(
						this.registro.tipo_contacto_ID &&
						this.registro.objetivo_contacto_ID
					)
				) &&
				this.registro.comentarios_previos
			)
		},

		accionesPropuestas () {
			for (let i = 0; i < this.registro.propuestas.length; i++) {
				const p = this.registro.propuestas[i]

				if (p.entrada_ID_presentada === this.registro.ID_entrada) {
					return true
				}

				if (p.entrada_ID_asociada === this.registro.ID_entrada) {
					return true
				}

				if (p.entrada_ID_decision === this.registro.ID_entrada) {
					return true
				}

				return false
			}
		},

		citaPasada () {
			return new Date().getTime() >= new Date(this.registro.fecha_inicio_contacto * 1000).getTime()
		},

		editable () {
			// Si la cita está cancelada no se puede editar
			if (this.registro.cancelada) {
				return false
			}

			if (this.usuario.ID !== this.registro.usuario_ID && !this.permisos.agenda_comercial_crear_todos) {
				return false
			}

			// Si es una entrada nueva se puede editar
			if (this.registro.ID_entrada === null || this.registro.ID_entrada === 'nuevo') {
				return true
			}

			// Si han pasado menos de 1 semana horas desde el registro de la cita
			const tiempo = 7 * 24 * 3600 * 1000
			if (new Date().getTime() - new Date(this.registro.fecha_registro * 1000).getTime() > tiempo) {
				return false
			}

			return true
		}
	},

	methods: {
		getEntrada (idEntrada) {
			if (!idEntrada && this.registro.ID_entrada) {
				idEntrada = this.registro.ID_entrada
			}

			axios.get('/agenda-comercial/php/api/get-entrada.php?ID_entrada=' + idEntrada)
				.then(res => {
					const reg = res.data.entrada
					reg.fechaContacto = new Date(reg.fecha_inicio_contacto * 1000)
					reg.horaIni = this.$moment(reg.fechaContacto).format('HH:mm')
					reg.horaFin = this.$moment(reg.fecha_fin_contacto * 1000).format('HH:mm')
					this.registro = reg
				})
				.catch(e => {
					this.$responseError(e)
					this.cerrar()
				})
		},
		nuevo () {
			const agenteID = (!this.permisos['agenda_comercial_crear_todos']) ? this.usuario.ID : null
			const infoAgente = (!this.permisos['agenda_comercial_crear_todos']) ? this.usuario.nombre + ' ' + this.usuario.apellidos : null

			this.registro = {
				ID_entrada: null,
				gestion: 0,
				usuario_ID: agenteID,
				usuarioNombre: infoAgente,
				cliente_ID: null,
				infoCliente: null,
				fechaContacto: (this.fecha) ? new Date(this.fecha.getTime()) : new Date(),
				horaIni: (this.hora) ? this.$moment(this.hora).format('HH:mm') : '',
				horaFin: (this.hora) ? this.$moment(this.hora.getTime() + 3600000).format('HH:mm') : '',
				tipo_contacto_ID: null,
				objetivo_contacto_ID: null,
				comentarios_previos: '',
				comentarios_finales: '',
				propuestas: []
			}
		},

		citaCancelada () {
			this.cancelando = false
			this.getEntrada()
		},

		seleccionaAgente (ev) {
			const nombre = ev.datos.nombre
			const apellidos = (typeof ev.datos.apellidos === 'string') ? ev.datos.apellidos : ''
			this.registro.usuario_ID = ev.datos.ID
			this.registro.usuarioNombre = nombre + ' ' + apellidos
			this.registro.usuarioAvatar = ev.datos.avatar
			this.registro.cliente_ID = null
			this.registro.infoCliente = null
			if (this.registro.gestion === 0) {
				this.$refs['inpCliente'].focus()
			}
		},

		quitarAgente () {
			this.registro.usuario_ID = null
			this.registro.usuarioNombre = null
			this.registro.usuarioAvatar = null
			this.registro.cliente_ID = null
			this.registro.infoCliente = null
		},

		seleccionaCliente (ev) {
			this.registro.cliente_ID = ev.datos.ID
			this.registro.clienteNombre = ev.datos.cliente
			this.$forceUpdate()
		},

		quitarCliente () {
			this.registro.cliente_ID = null
			this.registro.infoCliente = null
		},

		asignaPropuesta (datos) {
			if (datos.entrada_ID_asociada) {
				this.verEditorPropuestas = true
				this.copiarPropuesta = datos.ID_propuesta
				return
			}

			const asigna = {
				entrada_ID: this.registro.ID_entrada,
				propuesta_ID: datos.ID_propuesta
			}

			axios.post('/agenda-comercial/php/api/asigna-propuesta-entrada.php', asigna)
				.then(() => {
					this.getEntrada(this.registro.ID_entrada)
					this.copiarPropuesta = null
					this.$store.commit('toast/success', {
						titulo: 'Propuesta asignada',
						mensaje: 'Se ha asignado la propuesta correctamente'
					})
				})
				.catch(this.apiError.bind(this))
		},

		desasignaPropuesta (idPropuesta) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Desasignar propuesta',
				mensaje: '¿Quieres desasignar esta propuesta de esta entrada?',
				callback: acepta => {
					if (acepta) {
						const asigna = {
							propuesta_ID: idPropuesta
						}

						axios.post('/agenda-comercial/php/api/desasigna-propuesta-entrada.php', asigna)
							.then(() => {
								this.getEntrada(this.registro.ID_entrada)
								this.$store.commit('toast/info', {
									titulo: 'Propuesta desasignada',
									mensaje: 'Se ha desasignado la propuesta correctamente'
								})
							})
							.catch(this.apiError.bind(this))
					}
				}
			})
		},

		setPresentada (idPropuesta) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Marcar como presentada',
				mensaje: `¿Quieres marcar la propuesta como presentada en esta visita?
				Esta acción no se puede revertir.`,
				callback: acepta => {
					if (acepta) {
						const datos = {
							entrada_ID: this.registro.ID_entrada,
							propuesta_ID: idPropuesta
						}

						axios.post('/agenda-comercial/php/api/set-propuesta-presentada.php', datos)
							.then(res => {
								this.getEntrada(this.registro.ID_entrada)
								this.$store.commit('toast/success', {
									titulo: 'Propuesta presentada',
									mensaje: 'La propuesta se ha marcado como presentada'
								})
							})
							.catch(this.apiError.bind(this))
					}
				}
			})
		},

		setDecision (idPropuesta, decision) {
			const mensaje = (decision === 'aprobada') ? 'aprobar' : 'rechazar'

			this.$store.commit('alertas/confirm', {
				titulo: mensaje.toUpperCase(),
				mensaje: `¿Quieres ${mensaje} esta propuesta?`,
				callback: acepta => {
					if (acepta) {
						const datos = {
							propuesta_ID: idPropuesta,
							decision: decision,
							entrada_ID: this.registro.ID_entrada
						}

						axios.post('/agenda-comercial/php/api/set-propuesta-decision.php', datos)
							.then(() => {
								this.getEntrada(this.registro.ID_entrada)
								this.$store.commit('toast/success', {
									titulo: 'Propuesta finalizada',
									mensaje: 'Se ha marcado la propuesta como ' + decision
								})
							})
							.catch(this.apiError.bind(this))
					}
				}
			})
		},

		apiError (e) {
			this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: e.response.data.error
			})
		},

		guardar () {
			const objeto = JSON.parse(JSON.stringify(this.registro))
			const fechaContacto = this.$moment(this.registro.fechaContacto).format('D-M-YYYY')
			objeto.fechaContacto = fechaContacto

			axios.post('/agenda-comercial/php/api/set-entrada.php', objeto)
				.then(res => {
					this.getEntrada(res.data.entrada.ID_entrada)
					this.$emit('saved', res.data.entrada.ID_entrada)

					this.$store.commit('toast/success', {
						titulo: 'Entrada guardada',
						mensaje: 'Se ha guardado la entrada correctamente'
					})
				})
				.catch(this.apiError)
		},

		eliminar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar entrada',
				mensaje: `¿Quieres eliminar esta entrada?
				Esta acción no se podrá deshacer`,
				callback: acepta => {
					if (acepta) {
						axios.get('/agenda-comercial/php/api/del-entrada.php?ID_entrada=' + this.registro.ID_entrada)
							.then(() => {
								this.$store.commit('toast/success', {
									titulo: 'Entrada eliminada'
								})
								this.$emit('saved', this.registro.ID_entrada)
								this.cerrar()
							})
							.catch(this.$responseError)
					}
				}
			})
		},

		finalizar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Finalizar informe',
				mensaje: `Estás a punto de finalizar este informe.
				Una vez aceptes ya no podrás hacer modificaciones de ningún tipo.
				Por favor revisa bien tus comentarios y los estados de las propuestas antes de continuar.`,
				callback: (acepta) => {
					if (acepta) {
						axios.post('/agenda-comercial/php/api/set-finalizar-entrada.php', this.registro)
							.then(() => {
								this.getEntrada(this.registro.ID_entrada)

								this.$store.commit('toast/success', {
									titulo: 'Finalizada',
									mensaje: `Esta entrada ha quedado finalizada`
								})
							})
							.catch(e => {
								this.$store.commit('toast/danger', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},

		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/agenda-comercial/vue/componentes/editor/editor.vue